/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseUser } from './BaseUser';
const NormalUserParser = /* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('normal')],
    ['name', /* #__PURE__ */ parsers.maybeNull(codecString)],
    ['isTestStudent', codecBoolean, 'is_test_student'],
]), BaseUser);
export class NormalUser extends BaseUser {
    static decode(input) {
        return NormalUserParser.decode(input).map(res => new NormalUser(res));
    }
    static unsafeDecode(input) {
        return NormalUser.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NormalUserParser.encode(data);
    }
    static schema() {
        return NormalUserParser.schema();
    }
}
